module.exports = __webpack_public_path__ + "img/zhuanpan.83c2a020.png";